import { createSelector } from 'reselect';

const getErrors = state => state.errors;

export const getErrorState = createSelector(
    getErrors,
    (state, types) => types,
    (errors, types) => types.some(type => errors[type])
);
